var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: _vm.isCreate ? "520px" : "640px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.loadDetail
      }
    },
    [
      _vm.isCreate
        ? _c(
            "el-form",
            { attrs: { "label-width": "90px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "所属岗位", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择岗位" },
                      model: {
                        value: _vm.form.stationName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "stationName", $$v)
                        },
                        expression: "form.stationName"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(s) {
                      return _c("el-option", {
                        key: s.value,
                        attrs: { label: s.label, value: s.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "组名称", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "例如：华东销售组" },
                    model: {
                      value: _vm.form.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "groupName", $$v)
                      },
                      expression: "form.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "成员" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.searchUsers,
                        loading: _vm.userLoading,
                        placeholder: "输入姓名搜索并选择成员"
                      },
                      model: {
                        value: _vm.selectedUserIds,
                        callback: function($$v) {
                          _vm.selectedUserIds = $$v
                        },
                        expression: "selectedUserIds"
                      }
                    },
                    _vm._l(_vm.userOptions, function(u) {
                      return _c("el-option", {
                        key: u.userId,
                        attrs: { label: u.userName, value: u.userId }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "manage-members" },
            [
              _c("div", { staticClass: "group-info" }, [
                _c("span", { staticClass: "info-item" }, [
                  _c("label", [_vm._v("组名称")]),
                  _vm._v(_vm._s(_vm.form.groupName))
                ]),
                _c("span", { staticClass: "info-item" }, [
                  _c("label", [_vm._v("所属岗位")]),
                  _vm._v(_vm._s(_vm.form.stationName))
                ])
              ]),
              _c(
                "div",
                { staticClass: "member-toolbar" },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      filterable: "",
                      clearable: "",
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "default-value": _vm.addUserId,
                      "callback-params": { key: "userId" }
                    },
                    on: { parentCallBack: _vm.onAddUserSelected }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        icon: "el-icon-plus",
                        disabled: !_vm.pendingAddUser.userId
                      },
                      on: { click: _vm.addMember }
                    },
                    [_vm._v(" 添加成员 ")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.memberList,
                    border: "",
                    size: "small",
                    "max-height": "320",
                    "empty-text": "暂无成员，请搜索并添加"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "userName",
                      label: "姓名",
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userId", label: "用户ID", width: "120" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeMember(scope.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }